(() => {
  const initialise = () => {
    document.querySelectorAll('.yrp-header-search').forEach(search => {
      if (search.dataset.bound) return;
      search.dataset.bound = 'true';
      const trigger = search.querySelector(':scope > summary');
      const input = search.querySelector('input[type="search"]');
      const header = search.closest('.yrp-banner-header,.header');
      const close = restoreFocus => {
        search.open = false;
        trigger.setAttribute('aria-expanded','false');
        if (restoreFocus) trigger.focus();
      };
      trigger.setAttribute('aria-expanded',String(search.open));
      search.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded',String(search.open));
        if (!search.open) return;
        if (header) header.querySelectorAll('.yrp-header-links__item[open],.yrp-site-nav[open]').forEach(menu => { menu.open = false; });
        input.focus({preventScroll:true});
      });
      search.querySelector('[data-search-close]').addEventListener('click', () => close(true));
      search.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        close(true);
      });
      document.addEventListener('click', event => {
        if (search.open && !search.contains(event.target)) close(false);
      });
      document.addEventListener('toggle', event => {
        if (search.open && header && event.target !== search && header.contains(event.target) && event.target.matches('.yrp-header-links__item[open],.yrp-site-nav[open]')) close(false);
      },true);
    });
  };
  initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
